import React from "react";
export const my_pieces_cutout = (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
    >
        <g id="g32" transform="translate(-0.503 0.103)">
            <path
                id="rect52"
                d="M.5-.1v24h24V-.1ZM12.527,1.658a2.045,2.045,0,0,1,.857.192,1.647,1.647,0,0,1,.41,2.482c-.2.2-.308.411-.234.464a17.016,17.016,0,0,1,4.514,4.122c1.087,1.855,1,3.175-.358,5.142-1.091,1.587-1.183,2.12-.6,3.505.194.461.055.545-.895.545-.618,0-1.124.144-1.124.319,0,.55,1.516.927,3.725.927,2.38,0,3.271.48,3.618,1.948l.2.857H19.167a15.417,15.417,0,0,1-3.876-.309,2.254,2.254,0,0,1-.537-.19,3.837,3.837,0,0,1-1.5-1.251l-.651-.827-.651.827c-1.148,1.46-2.127,1.75-5.911,1.75H2.565l.2-.857c.348-1.468,1.239-1.948,3.618-1.948a10.3,10.3,0,0,0,3.005-.348c.182-.1.365-.189.547-.274a.405.405,0,0,0,.173-.3c0-.176-.506-.319-1.124-.319-.95,0-1.089-.084-.895-.545.582-1.385.491-1.918-.6-3.505C6.078,12,6.021,10.685,7.263,8.727A11.673,11.673,0,0,1,9.834,6.114c.924-.665,1.741-1.254,1.815-1.311s-.031-.268-.234-.471a2.082,2.082,0,0,1-.369-1.248,1.41,1.41,0,0,1,1.48-1.426Zm-.7,17.007-.026.018.022.025c0-.014,0-.029,0-.043Zm2.607.285-.273.008h.281l-.008-.008Zm1.256,1.393,0,.017h.006l0-.017Zm1.743.212v0l.374.043-.374-.046Zm-10.42.265-.5,0h.5l0,0Z"
            />
        </g>
    </svg>
);
